<template>
  <div class="font-roboto-condensed register-workflow">
    <div class="mainLogoPosition text-center">
      <img src="@/assets/gregorys_logo.png" style="width: 200px" />
    </div>
    <div class="greetings">
      <h1>{{ `${$translation('b2b_hello')} ${userInfo.first_name}!` }}</h1>
      <p>{{ $translation('b2b_few_steps_more') }}</p>
    </div>

    <el-row>
      <el-col>
        <p
          class="section-title"
          v-html="this.$translation('b2b_your_info')"
        ></p>
        <el-form :model="userInfo" class="user-info" readonly>
          <el-row :gutter="5">
            <el-col :span="12" :xs="24">
              <el-row :gutter="5">
                <el-col :span="10">
                  <el-form-item
                    prop="country_code"
                    :label="this.$translation('b2b_country_code_short')"
                  >
                    <el-input v-model="userInfo.mobile_country_code_text"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="14">
                  <el-form-item
                    prop="mobile"
                    :label="this.$translation('b2b_mobile')"
                  >
                    <el-input v-model="userInfo.mobile"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="email"
                :label="this.$translation('b2b_email')"
              >
                <el-input v-model="userInfo.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="5">
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="first_name"
                :label="this.$translation('b2b_first_name')"
              >
                <el-input v-model="userInfo.first_name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="last_name"
                :label="this.$translation('b2b_last_name')"
              >
                <el-input v-model="userInfo.last_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="5" v-if="!this.registeredDataGetter['is_trainee']">
            <el-col>
              <el-form-item
                prop="job_position"
                :label="this.$translation('b2b_job_position')"
              >
                <el-input v-model="userInfo.job_position"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row
            class="mt-3"
            :class="{
              'd-none': !userInfo.stores
            }"
          >
            <span class="label">{{ this.$translation('b2b_stores') }}</span>
            <ul class="list-of-stores">
              <li v-for="store in userInfo.stores" :key="store">
                {{ store }}
              </li>
            </ul>
          </el-row>
        </el-form>
        <p
          class="section-title mt-3"
          v-html="this.$translation('b2b_select_password')"
        ></p>
        <el-form
          ref="PassResetForm"
          :model="passwordResetForm"
          :rules="passwordResetRules"
          status-icon
          label-position="top"
          label-width="120px"
          class="password-reset-form"
        >
          <el-row :gutter="5">
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="selectPassword"
                ref="select_password"
                class="no-error-icon"
                :label="this.$translation('b2b_select_pass')"
              >
                <el-input
                  :type="!passwordVisible ? 'password' : 'text'"
                  v-model="passwordResetForm.selectPassword"
                  :placeholder="this.$translation('b2b_select_pass')"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-view"
                    @click="togglePassVissible()"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :xs="24">
              <el-form-item
                prop="reEnterPassword"
                ref="re_enter_password"
                class="no-error-icon"
                :label="this.$translation('b2b_reenter_pass')"
              >
                <el-input
                  :type="!password2Visible ? 'password' : 'text'"
                  v-model="passwordResetForm.reEnterPassword"
                  :placeholder="this.$translation('b2b_reenter_pass')"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-view"
                    @click="togglePass2Vissible()"
                  ></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item prop="terms" class="mb-4">
            <el-checkbox
              v-model="passwordResetForm.terms"
              value="terms"
              name="terms"
              ><span v-html="this.$translation('b2b_terms')"></span
            ></el-checkbox>
          </el-form-item>
          <el-form-item prop="consent_email" class="mb-4">
            <el-checkbox
              v-model="passwordResetForm.consent_email"
              value="email"
              name="consent_email"
              ><span v-html="this.$translation('b2b_consent_email')"></span
            ></el-checkbox>
          </el-form-item>
          <p class="section-title mt-1">
            {{ this.$translation('b2b_confirm_phone') }}
          </p>
          <p class="section-subtitle">
            {{ this.$translation('b2b_confirm_phone_text') }}
          </p>
          <el-form-item
            prop="verifyMobile"
            id="verifyMobile"
            :class="{
              'show-element': validPasswords,
              'hide-with-prepend': !verifyCodeSent,
              'no-error-padding': !verifyCodeSent
            }"
          >
            <div
              class="verify-button"
              :class="{
                disabled:
                  !validPasswords || !passwordResetForm.terms || verifyCodeSent
              }"
              @click="verifyPhone()"
            >
              {{ this.$translation('b2b_send_code') }}
            </div>
            <div
              class="pin-container"
              :class="{
                hidden: !validPasswords || !verifyCodeSent
              }"
            >
              <div
                class="rsend-container"
                :class="{
                  hidden: !verifyCodeSent
                }"
              >
                <span>{{ this.$translation('b2b_rsend_code') }}</span>
                <span @click="verifyPhone()">{{
                  this.$translation('b2b_rsend_text')
                }}</span>
              </div>
              <PinInput
                ref="pinInput"
                :title="this.$translation('b2b_introduce_pin')"
                :pinLenght="6"
                @updatePin="updatePin"
                v-model="passwordResetForm.verifyMobile"
                :class="{
                  hidden: !verifyCodeSent
                }"
              >
              </PinInput>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="reset-pass-btn"
              @click="onSubmit"
              :disabled="isValidVerificationCode"
              >{{ this.$translation('b2b_complete_registration') }}</el-button
            >
            <p
              class="text-center pointer resetText"
              @click="$router.push('/register')"
            >
              {{ this.$translation('b2b_back_to_register') }}
            </p>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SetPassApi, verifyMobile } from '@/utils/echoApi';
import { isValidPassword } from '@/utils/validate';
import PinInput from '@/components/Forms/PinInput';
import {
  validateVerificationCode,
  validateRequiredConsent
} from '@/components/Shared/validators/registerValidators';
export default {
  name: 'PasswordReset',
  components: {
    PinInput
  },
  data() {
    const validateSelectPass = (rule, value, callback) => {
      if (this.$refs.re_enter_password.fieldValue && !isValidPassword(value)) {
        this.validPasswords = false;
        this.showVerificationCode = false;
        callback(
          new Error(
            'Insert min length 8 chars, one uppercase, one digit, one special char'
          )
        );
      } else if (this.$refs.re_enter_password.fieldValue) {
        this.$refs.PassResetForm.validateField('reEnterPassword');
        callback();
      } else {
        callback();
      }
    };
    const validateConfirmPass = (rule, value, callback) => {
      if (
        this.$refs.re_enter_password.fieldValue &&
        this.$refs.select_password.fieldValue &&
        this.passwordResetForm.selectPassword !==
          this.passwordResetForm.reEnterPassword
      ) {
        this.validPasswords = false;
        this.showVerificationCode = false;
        callback(new Error('Passwords must match'));
      } else if (
        this.$refs.select_password.fieldValue &&
        !isValidPassword(this.$refs.select_password.fieldValue)
      ) {
        this.validPasswords = false;
        this.showVerificationCode = false;
        this.$refs.PassResetForm.validateField('selectPassword');
        callback();
      } else if (
        this.$refs.re_enter_password.fieldValue.length &&
        this.$refs.select_password.fieldValue.length
      ) {
        this.validPasswords = true;
        this.showVerificationCode = true;
        callback();
      } else if (
        !this.$refs.re_enter_password.fieldValue.length ||
        !this.$refs.select_password.fieldValue.length
      ) {
        this.validPasswords = false;
        this.showVerificationCode = false;
      }
    };
    return {
      hash: '',
      showVerificationCode: false,
      verifyCodeSent: false,
      validPasswords: false,
      passwordVisible: false,
      password2Visible: false,
      passwordResetForm: {
        verifyMobile: '',
        selectPassword: '',
        reEnterPassword: '',
        terms: false,
        consent_email: false
      },
      passwordResetRules: {
        verifyMobile: [
          {
            required: true,
            trigger: 'blur',
            validator: validateVerificationCode
          }
        ],
        selectPassword: [
          { required: true, trigger: 'change', validator: validateSelectPass }
        ],
        reEnterPassword: [
          { required: true, trigger: 'change', validator: validateConfirmPass }
        ],
        terms: [
          {
            required: true,
            message: 'Required',
            validator: validateRequiredConsent
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters('data', ['hostname']),
    ...mapGetters('data', ['hostname', 'registeredDataGetter']),

    isValidVerificationCode() {
      return this.passwordResetForm.verifyMobile.length !== 6;
    },

    userInfo() {
      return {
        mobile: this.registeredDataGetter['mobile'],
        mobile_country_code_text: this.registeredDataGetter['mobile_country_code'] ? '+' + this.registeredDataGetter['mobile_country_code'] : '',
        first_name: this.registeredDataGetter['first_name'],
        last_name: this.registeredDataGetter['last_name'],
        email: this.registeredDataGetter['email'],
        stores:
          this.registeredDataGetter['store'] &&
          this.registeredDataGetter['store'].length
            ? this.registeredDataGetter['store']
            : '',
        job_position: this.registeredDataGetter['job_position']
      };
    }
  },
  created() {
    this.hash = this.$route.query.m;
    this.getRegisteredData(this.hash);
  },
  methods: {
    ...mapActions('data', ['getRegisteredData']),
    onSubmit() {
      this.$refs['PassResetForm'].validate(valid => {
        if (valid) {
          this.sendResetPassRequest();
        } else {
          // console.log('Err:', valid);
          return false;
        }
      });
    },
    sendResetPassRequest() {
      this.$http
        .post(
          'https://' + this.hostname + SetPassApi, // /auth/activate
          {
            hash: this.hash,
            code: this.passwordResetForm.verifyMobile,
            password: this.passwordResetForm.selectPassword,
            consent_email: this.passwordResetForm.consent_email,
            terms: this.passwordResetForm.terms
          },
          { headers: { Accept: 'application/json' } }
        )
        .then(response => {
          this.$message({
            type: response.data.status,
            message: this.$translation(response.data.message)
          });
          this.$router.push('/');
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$translation(error.response.data.message)
          });
        });
    },

    verifyPhone() {
      this.$http
        .post(
          'https://' + this.hostname + verifyMobile,
          { hash: this.hash },
          {
            headers: { Accept: 'application/json' }
          }
        )
        .then(response => {
          // console.log(response);
          this.verifyCodeSent = true;
          this.$refs.pinInput.setFocus();
          this.$message({
            type: 'success',
            message: this.$translation(response.data.message)
          });
          this.showVerificationCode = true;
        })
        .catch(error => {
          this.$message({
            type: 'error',
            message: this.$translation(error.response.data.message)
          });
        });
    },

    togglePassVissible() {
      this.passwordVisible = !this.passwordVisible;
    },

    togglePass2Vissible() {
      this.password2Visible = !this.password2Visible;
    },

    updatePin(pin) {
      this.passwordResetForm.verifyMobile = pin;
    }
  }
};
</script>

<style lang="scss">
.hidden {
  height: 0 !important;
  padding: 0 !important;
  overflow: hidden;
}

.register-workflow {
  padding-right: 10px;
  padding-left: 10px;
}

.greetings {
  text-align: center;

  h1 {
    font-weight: bold;
    font-size: 32px;
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 15px;
  }

  p {
    font-size: 20px;
    width: 80%;
    margin: 0 auto 22px;
  }
}

.password-reset-form {
  .el-input__inner {
    font-weight: 600;
  }
  .el-input__suffix {
    color: #509fec;
  }
}

.section-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 0;
  margin-top: 0;
}

.section-subtitle {
  text-align: center;
  font-size: 14px;
  margin-top: 0px;
}

.verify-button {
  background-color: transparent;
  color: #65b45b;
  border: 1px solid black;
  font-size: 18px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 220px;
  margin: 10px auto 8px;
  border-radius: 12px;
  padding: 4px 20px;
  box-sizing: border-box;
  transition: all 0.3s ease-in-out;
}

.verify-button.disabled {
  border: 1px solid #a9a9a9;
  color: #a9a9a9;
  pointer-events: none;
}

.form-item-hidden {
  height: 0;
}

.user-info {
  list-style: none;
  padding: 0;
}

.user-info {
  pointer-events: none;
}

.user-info .el-form-item {
  margin-bottom: 8px;
}

.register-workflow .reset-pass-btn {
  width: 100%;
  margin-top: 10px;
  background-color: #00b724 !important;
  padding: 14px 20px;
  font-size: 20px;
  border-radius: 12px;
  transition: all 0.3s ease-in-out;
}

.is-disabled.reset-pass-btn {
  background-color: #a9a9a9 !important;
}

.resetText {
  margin-bottom: 0;
}

.label {
  color: #606266;
}

.list-of-stores {
  margin-top: 6px;
  padding-left: 18px;
}

.list-of-stores > li {
  margin-bottom: 10px;
}

.el-input__icon {
  cursor: pointer;
}

.show-element {
  display: block !important;
}

.pin-container {
  width: 80%;
  margin: 0 auto;
  height: 150px;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.rsend-container {
  display: flex;
  justify-content: space-between;
  background-color: #f4f4f4;
  color: #a9acaf;
  border-radius: 2px;
  padding: 2px 25px;
  margin-bottom: 8px;
  overflow: hidden;
}

.rsend-container > span {
  font-weight: bold;
}

.rsend-container > span:last-child {
  color: #8f7ee5;
  cursor: pointer;
}

.rsend-container > span:last-child:hover {
  text-decoration: underline;
}

.el-checkbox a {
  color: black;
  display: inline-block;
  text-decoration: underline;
}

// .el-checkbox__label {
//   display: inline-grid;
//   grid-template-columns: 10px auto;
// }

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266 !important;
}

.el-checkbox + .el-form-item__error {
  position: relative;
  padding-top: 0;
  margin-left: 34px;
}

.el-form-item--medium .el-form-item__content {
  line-height: 26px;
}

@media (max-width: 531px) {
  .register-workflow {
    padding-right: 0px;
    padding-left: 0px;
  }

  .pin-container {
    width: 90%;
  }

  .register-workflow .reset-pass-btn {
    padding: 14px 10px;
    font-size: 16px;
  }

  .rsend-container {
    flex-direction: column;
    text-align: center;
    line-height: 22px;
  }

  .rsend-container > span {
    margin-bottom: 6px;
  }

  .pin-container {
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/password-reset/index.vue